export default "__VITE_ASSET__Bx1i_PJc__"